import "../styles/TermsOfService.css";

function TermsOfService() {
  return (
    <div className="tos-container">
      <div className="tos-box">
        <h1 className="tos-title">Terms of Service</h1>
        <p className="tos-text">
          Welcome to Huge Notifier! By using this bot, you agree to the following terms and conditions.
          If you do not agree, please do not use the bot.
        </p>

        <section className="tos-section">
          <h2>1. Use of the Bot</h2>
          <ul>
            <li>This bot is provided as-is, with no guarantees of uptime or functionality.</li>
            <li>You must comply with Discord's Terms of Service and Community Guidelines.</li>
            <li>Misuse of the bot, including spam or malicious activities, is prohibited.</li>
          </ul>
        </section>

        <section className="tos-section">
          <h2>2. Data Collection</h2>
          <ul>
            <li>The bot may store user data such as Discord IDs, messages, and interactions.</li>
            <li>We do not sell or share your data with third parties.</li>
            <li>Refer to our Privacy Policy for more details.</li>
          </ul>
        </section>

        <section className="tos-section">
          <h2>3. Limitation of Liability</h2>
          <ul>
            <li>We are not responsible for any issues arising from the use of this bot.</li>
            <li>The bot owner reserves the right to remove access to the bot at any time.</li>
          </ul>
        </section>

        <section className="tos-section">
          <h2>4. Changes to Terms</h2>
          <ul>
            <li>These terms may be updated at any time. Continued use of the bot after updates implies acceptance of the new terms.</li>
          </ul>
        </section>

        <footer className="tos-footer">Last Updated: 12/02/2025 15:39 GMT+1</footer>
      </div>
    </div>
  );
}

export default TermsOfService;
